import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const LiveChat: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--live-chat2')}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M19,7 L6,7 L6,16 L7.73333333,16 L7.73333333,19 L12,16 L19,16 L19,7 Z M18,8 L18,15 L11.6836262,15 L8.733,17.073 L8.73333333,15 L7,15 L7,8 L18,8 Z"
      id="Chat-Icon"
    />
  </svg>
);

export default LiveChat;
